/**
 * Meta Pixel (Dataset 27794626650200894, Kolorfirst LLC). Single source of
 * truth so every page inits the same pixel exactly once. Idempotent: the fbq
 * guard prevents double-loading across Inertia navigations, so it's safe to
 * call from any page's mount effect.
 *
 * Pair with track() in ./track for firing events (it calls window.fbq).
 */
export const META_PIXEL_ID = '27794626650200894';

export function initMetaPixel(): void {
  if (!META_PIXEL_ID || typeof window === 'undefined' || (window as any).fbq) return;
  /* eslint-disable */
  (function (f: any, b, e, v, n?: any, t?: any, s?: any) {
    if (f.fbq) return;
    n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  (window as any).fbq('init', META_PIXEL_ID);
  (window as any).fbq('track', 'PageView');
  /* eslint-enable */
}
